export default "__VITE_ASSET__BbSgdtrX__"